import { type FC } from 'react';

import styles from './styles.scss';
import MediaItem from './MediaItem.tsx';

type Props = {
    isActive: boolean;
    element: {
        url?: string;
        path?: string;
        caption?: string;
        mediaType: 'PHOTO' | 'VIDEO';
    };
    useSrcSet: boolean;
    vimeoStorefrontVideoHLSPlayerFF: boolean;
    muxMonitoringFF: boolean;
    isMobile: boolean;
};

const MediaCarouselItem: FC<Props> = ({
    isActive,
    element,
    useSrcSet,
    vimeoStorefrontVideoHLSPlayerFF,
    muxMonitoringFF,
    isMobile,
}) => {
    return (
        <div
            className={styles.carouselItem}
            style={{ opacity: isActive ? 1 : 0.3 }}
            data-tn="media-carousel-item"
        >
            <MediaItem
                {...element}
                useSrcSet={useSrcSet}
                vimeoStorefrontVideoHLSPlayerFF={vimeoStorefrontVideoHLSPlayerFF}
                muxMonitoringFF={muxMonitoringFF}
                isMobile={isMobile}
            />
        </div>
    );
};

export default MediaCarouselItem;
